export default "__VITE_ASSET__CpwFkMax__"